"use strict";
///<reference path="../typings/index.d.ts" />
var EscapeStack_1 = require('./EscapeStack');
var domEventHandler_1 = require('./domEventHandler');
var globalStack;
function initStack() {
    var escapeStack = new EscapeStack_1.EscapeStack();
    domEventHandler_1.handleEscapeKeydown(document.body, escapeStack.pop.bind(escapeStack));
    return escapeStack;
}
function createEscapeStack(global) {
    if (global === void 0) { global = false; }
    if (!global) {
        return initStack();
    }
    if (!globalStack) {
        globalStack = initStack();
    }
    return globalStack;
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createEscapeStack;
//# sourceMappingURL=index.js.map